import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';

@Component({
  standalone: true,
  selector: 'app-bar-chart',
  templateUrl: 'bar-chart.component.html',
  styleUrls: ['bar-chart.component.scss'],
  imports: [CommonModule, NgChartsModule],
})
export class BarChartComponent implements OnChanges {
  chartVisible: boolean = true;

  @Input() title: string;
  @Input() chartOptions: any;
  @Input() datasets: any[];
  @Input() labels: string[];

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['datasets'] && !changes['datasets'].isFirstChange()) ||
      (changes['labels'] && !changes['labels'].isFirstChange()) ||
      (changes['chartOptions'] && !changes['chartOptions'].isFirstChange())
    ) {
      this.forceRedraw();
    }
  }

  private forceRedraw(): void {
    this.chartVisible = false;
    setTimeout(() => {
      this.chartVisible = true;
    }, 0);
  }
}
